// Registry of the selected 20261015 captures (owner acceptance pending).
// Historical snapshot names stay untouched; pages reference keys explicitly.

export type SelectedCaptureTheme = 'light' | 'dark';

export const CAPTURE_SNAPSHOT = 'snapshots/20261015-selected';

export const CAPTURE_BASES = {
  dashboardMap: `${CAPTURE_SNAPSHOT}/dashboard-map`,
  dashboardList: `${CAPTURE_SNAPSHOT}/dashboard-list`,
  dashboardHybrid: `${CAPTURE_SNAPSHOT}/dashboard-hybrid`,
  selectedEvent: `${CAPTURE_SNAPSHOT}/map-event-selected-card`,
  garageDetail: `${CAPTURE_SNAPSHOT}/garage-media-detail`,
  garageEngine: `${CAPTURE_SNAPSHOT}/garage-media-engine`,
  garageTires: `${CAPTURE_SNAPSHOT}/garage-media-tires`,
  profile: `${CAPTURE_SNAPSHOT}/profile-sample`,
  publicProfile: `${CAPTURE_SNAPSHOT}/public-profile-sample`,
  friendProfile: `${CAPTURE_SNAPSHOT}/friend-public-profile`,
  proOverview: `${CAPTURE_SNAPSHOT}/pro-active-overview`,
  analytics: `${CAPTURE_SNAPSHOT}/premium-analytics`,
  publicStats: `${CAPTURE_SNAPSHOT}/stats-sample`,
  achievements: `${CAPTURE_SNAPSHOT}/achievements-sample`,
  friends: `${CAPTURE_SNAPSHOT}/friends-list`,
  hostTools: `${CAPTURE_SNAPSHOT}/host-event-management-bottom`,
  profilePrivacy: `${CAPTURE_SNAPSHOT}/profile-edit-privacy`,
  privacyDefaults: `${CAPTURE_SNAPSHOT}/profile-privacy-events-garage`,
} as const;

export type SelectedCaptureKey = keyof typeof CAPTURE_BASES;

// Full-size original — the lightbox always loads this PNG.
export const selectedCaptureSrc = (
  key: SelectedCaptureKey,
  theme: SelectedCaptureTheme
): string =>
  `/assets/screenshots/ios-delivery/${CAPTURE_BASES[key]} - ${
    theme === 'dark' ? 'Dark' : 'Light'
  }.png`;

// Keys whose frozen previewWidth is 660 get a 396px srcset derivative;
// 1024 crop-source keys render whole and stay single-resolution.
export const PHONE_CAPTURE_KEYS: ReadonlySet<SelectedCaptureKey> = new Set(
  (
    [
      'dashboardMap',
      'dashboardList',
      'dashboardHybrid',
      'selectedEvent',
      'garageDetail',
      'profile',
      'publicProfile',
      'friendProfile',
      'proOverview',
      'publicStats',
      'achievements',
      'friends',
      'hostTools',
      'profilePrivacy',
      'privacyDefaults',
    ] as SelectedCaptureKey[]
  )
);
